import React from 'react'; // eslint-disable-line
import { Trans } from 'react-i18next';
import Dialog from './Dialog';
import MediaLogo from '../svg/MediaLogo';
import i18n from '../../i18n';

class InputDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Value: '',
        };
    }

    closeDialog = () => {
        if (this.props.CloseDialog) {
            this.props.CloseDialog();
        }
    }

    generateClass = (className) => {
        return className;
    }

    executeAction = () => {
        this.executeActionWithValue(this.state.Value);
    }

    executeActionWithValue = (val) => {
        if (this.props.Action) {
            this.props.Action(val);
        }
    }

    updateValue = (e) => {
        this.setState({
            Value: e.target.value,
        });
    }

    onKeyDownFn = (e) => {
        if (e.keyCode === 13) {
            this.executeActionWithValue(e.target.value);
        } else if (e.keyCode === 27) {
            this.closeDialog();
        }
    }

    render() {
        const {
            Visible,
            SVGIconPath,
            SVGIconFill,
            SVGIconFillRule,
            Placeholder,
            ActionName,
        } = this.props;
        const { value } = this.props;

        let hint = '';
        if (Placeholder) {
            hint = (
                <div className="input-hint">
                    {i18n.t('example')}
                    {' '}
                    <Trans
                        components={[<br />]}
                    >
                        {Placeholder}
                    </Trans>
                </div>
            );
        }

        return (
            <Dialog
                Visible={Visible}
                CloseDialog={this.closeDialog}
                ExecuteAction={this.executeAction}
                ActionName={ActionName}
                ShowButtons
            >
                <MediaLogo
                    SVGIconPath={SVGIconPath}
                    SVGFillRule={SVGIconFillRule}
                    SVGIconFill={SVGIconFill}
                />
                <h2>{this.props.Title}</h2>
                <div className="form-control form-control__dialog">
                    <label>{this.props.Description}</label>
                    <input
                        className="input-dialog"
                        ref={(input) => {
                            this.textInput = input;
                        }}
                        type="text"
                        value={value}
                        onBlur={this.updateValue}
                        placeholder={Placeholder}
                        onKeyDown={this.onKeyDownFn}
                        autoFocus // eslint-disable-line
                    />
                    {hint}
                </div>
            </Dialog>
        );
    }
}

export default InputDialog;
